import { Capacitor } from '@capacitor/core';
import { Preferences } from '@capacitor/preferences';

/** Нативная платформа (android/ios) vs web (браузер/dev). */
export function isNative(): boolean {
  return Capacitor.isNativePlatform();
}

export function platformName(): string {
  return Capacitor.getPlatform();
}

/**
 * Async key-value. На web плагин Preferences использует localStorage,
 * на native — нативное хранилище. Единый интерфейс под offline-персист.
 * (Секьюрное хранилище refresh-токена — отдельным плагином позже; см. tokenStore.)
 */
export const kv = {
  async get(key: string): Promise<string | null> {
    const { value } = await Preferences.get({ key });
    return value ?? null;
  },
  async set(key: string, value: string): Promise<void> {
    await Preferences.set({ key, value });
  },
  async remove(key: string): Promise<void> {
    await Preferences.remove({ key });
  },
  async getJson<T>(key: string): Promise<T | null> {
    const raw = await this.get(key);
    if (raw == null) return null;
    try {
      return JSON.parse(raw) as T;
    } catch {
      return null;
    }
  },
  async setJson(key: string, value: unknown): Promise<void> {
    await this.set(key, JSON.stringify(value));
  },
};
